var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox relative" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:free-redeem:record"],
            expression: "['platform:free-redeem:record']",
          },
        ],
      },
      [
        _c(
          "el-card",
          {
            staticClass: "ivu-mt",
            attrs: {
              bordered: false,
              shadow: "never",
              "body-style": { padding: 0 },
            },
          },
          [
            _c(
              "div",
              { staticClass: "padding-add" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: "",
                      size: "small",
                      "label-position": "right",
                    },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "批次ID：" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请输入批次ID", clearable: "" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery($event)
                            },
                          },
                          model: {
                            value: _vm.queryParams.batchId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "batchId",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "queryParams.batchId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "兑换码：" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请输入兑换码", clearable: "" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery($event)
                            },
                          },
                          model: {
                            value: _vm.queryParams.exchangeCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "exchangeCode",
                                _vm._n(
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              )
                            },
                            expression: "queryParams.exchangeCode",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.handleQuery },
                          },
                          [_vm._v("查询")]
                        ),
                        _c("el-button", { on: { click: _vm.resetQuery } }, [
                          _vm._v("重置"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "el-card",
          {
            staticClass: "table-card mt14",
            attrs: { "body-style": { padding: "20px" } },
          },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                attrs: { data: _vm.recordList, size: "small" },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "batchId", label: "批次ID", align: "center" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "exchangeCode",
                    label: "兑换码",
                    width: "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "status", label: "状态", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.formatter(scope.row.status, "status"))
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "exchangeTime",
                    label: "兑换时间",
                    width: "160",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "userId",
                    label: "用户ID",
                    width: "100",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "couponUserId",
                    label: "用户优惠券ID",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createTime",
                    label: "创建时间",
                    width: "160",
                  },
                }),
              ],
              1
            ),
            _c("el-pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.total > 0,
                  expression: "total > 0",
                },
              ],
              attrs: {
                background: "",
                "current-page": _vm.queryParams.page,
                "page-size": _vm.queryParams.limit,
                "page-sizes": [10, 20, 30, 50],
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.queryParams, "page", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.queryParams, "page", $event)
                },
                "update:pageSize": function ($event) {
                  return _vm.$set(_vm.queryParams, "limit", $event)
                },
                "update:page-size": function ($event) {
                  return _vm.$set(_vm.queryParams, "limit", $event)
                },
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }